"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.66797 8.00044C2.66797 7.82362 2.73821 7.65404 2.86323 7.52901C2.98826 7.40398 3.15782 7.33374 3.33464 7.33374H12.668C12.8448 7.33374 13.0143 7.40398 13.1394 7.52901C13.2644 7.65404 13.3346 7.82362 13.3346 8.00044C13.3346 8.17726 13.2644 8.34684 13.1394 8.47187C13.0143 8.5969 12.8448 8.66714 12.668 8.66714H3.33464C3.15782 8.66714 2.98826 8.5969 2.86323 8.47187C2.73821 8.34684 2.66797 8.17726 2.66797 8.00044Z",
    fill: fill
  }));
};

exports["default"] = _default;